import React from "react";
import fields from "../../json/GalleryFields.json";
import FormInput from "Common/Custom/FormInput";
import FormInputFile from "Common/Custom/FormInputFile";
import FormSubmitButton from "Common/Custom/FormSubmitButton";
import PageBody from "Common/Custom/PageBody";
import { HeadingOne } from "Common/Custom/HeadingOne";
import Switch from "Common/Custom/Switch";

const EditGalleryForm = ({
  values,
  errors,
  handleChange,
  handleFileChange,
  handleSubmit,
  loading,
  imagePreview,
  title,
}) => {
  const { formdata } = fields;

  return (
    <PageBody onSubmit={handleSubmit} headerchildren={<HeadingOne>{title}</HeadingOne>}>
      {formdata.map((field) => {

        if (field.type === "file") {
          return (
            <FormInputFile
              key={field.name}
              field={field}
              handleChange={handleFileChange}
              error={errors[field.name]}
              imagePreview={imagePreview}
            />
          );
        }

        if (field.type === "switch") {
          return (
            <Switch
              values={values[field.name]}
              handleChange={handleChange}
              field={field}
              ValueOne="1"
              ValueTwo="0"
              LabelOne="Active"
              LabelTwo="Inactive"
            />
          );
        }

        return (
          <FormInput
            key={field.name}
            field={field}
            value={values[field.name]}
            handleChange={handleChange}
            error={errors[field.name]}
          />
        );
      })}

      

      <FormSubmitButton label="Update" loading={loading} colSize="col-12" align="end" />
    </PageBody>
  );
};

export default EditGalleryForm;
